"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var CardSolid = function (props) {
    return ((0, jsx_runtime_1.jsxs)(Icon_1.default, tslib_1.__assign({}, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: 'M16 84H176V149C176 154.523 171.523 159 166 159H26C20.4772 159 16 154.523 16 149V84Z', fill: 'currentColor' }), (0, jsx_runtime_1.jsx)("path", { d: 'M16 42C16 36.4772 20.4772 32 26 32H166C171.523 32 176 36.4772 176 42V64H16V42Z', fill: 'currentColor' })] })));
};
/**
 * @deprecated Use Icon from Antd
 * https://ant.design/components/icon/
 */
exports.default = CardSolid;
